import { StyleSheet, Text, View, Image } from 'react-native'


const WelcomeEight = () => {
    return (
        <>
            <Text
                style={{
                    fontWeight: 'bold',
                    fontSize: 27,
                    color: 'white',
                    alignSelf: 'center'
                }}
            > Shift Schedule</Text>
            <Image
                source={require('../../../static/images/Welcome-Shifts.png')}
                style={[styles.appBrand]}
                resizeMode="contain"
            />
        </>
    )
}

export default WelcomeEight

const styles = StyleSheet.create({
    rectangle: {
        alignSelf: 'center',
        marginTop: '20%',
        width: '30%',
        height: '64%',
        //backgroundColor: 'white',
        borderRadius: 15
    },
    appBrand: {
        width: '50%',
        height: '70%',
        alignSelf: 'center'
        // marginTop:'10%'
    }
})
